import { useStore } from 'effector-react'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { Content } from './Content'
import { formModel } from './Content/Form'
import { formSubmit, formSubmitFx } from './model'

type FillIndividualEntrepreneurDrawerProps = {
  isShow: boolean
  onClose: () => void
}

export function FillIndividualEntrepreneurDrawer({
  isShow,
  onClose,
}: FillIndividualEntrepreneurDrawerProps) {
  const isSubmitting = useStore(formSubmitFx.pending)

  const handleSubmitForm = (formValues: formModel.FormValues) => {
    formSubmit({ formValues, fn: onClose })
  }

  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <Content onSuccess={handleSubmitForm} isSubmitting={isSubmitting} />
    </DrawerComponent>
  )
}
